import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MenuItemBaseComponent } from '../menu-item-base/menu-item-base.component';
import { ConfigService } from '../../../../core/services/config.service';
import { MenuItemControlButtonComponent } from "../menu-item/menu-item-control-button/menu-item-control-button.component";
import { ItemWithOptionUpdateComponent } from "../item-with-option-update/item-with-option-update.component";
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ReadMoreComponent } from "../../../../common/read-more/read-more.component";
import { CommonModule } from '@angular/common';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { PricePipe } from '../../../../core/pipes/price.pipe';

@Component({
    selector: 'app-menu-item-horizontal-image',
    standalone: true,
    imports: [
        CommonModule,
        NgbTooltipModule,
        TranslocoCurrencyPipe,
        PricePipe,
        MenuItemControlButtonComponent,
        ItemWithOptionUpdateComponent,
        ReadMoreComponent
    ],
    templateUrl: './menu-item-horizontal-image.component.html',
    styleUrls: ['./menu-item-horizontal-image.component.css'],
})
export class MenuItemHorizontalImageComponent extends MenuItemBaseComponent implements OnInit {

    @Input() productStyle;
    @Input() largeFormat;

    readonly MOBILE_THRESHOLD = 700;
    isMobile: boolean = false;

    constructor(public translate: TranslocoService, public configService: ConfigService) {
        super(translate, configService)
    }

    ngOnInit(): void {
        super.ngOnInit()
        this.isMobile = window.innerWidth < this.MOBILE_THRESHOLD
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.isMobile = window.innerWidth < this.MOBILE_THRESHOLD
    }

}
